import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';


@Directive({
  selector: '[custom-bg-pc]' // Attribute selector
})
export class CustomBgPcDirective implements AfterViewInit {

  constructor(
    private el: ElementRef, 
    private colorProvider: ColorProvider, 
    private events: Events
  ) {

    

  }

  ngAfterViewInit() {
    this.update();
    
    this.events.subscribe('color:updated', () => {
      this.update();
    });
  }

  update() {
    this.colorProvider.getBgPC().then( bg => this.el.nativeElement.style.backgroundImage = bg);
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-bg-pc/custom-bg-pc.ts